import { render, staticRenderFns } from "./InverterModuleFormGroup.vue?vue&type=template&id=283b2aba&"
import script from "./InverterModuleFormGroup.vue?vue&type=script&lang=ts&"
export * from "./InverterModuleFormGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports